import { z } from 'zod';

export const semanticProviderDetailMaxLength = 500;

const statusZod = z.number().int().min(100).max(599);
const messageZod = z.string().min(1).max(semanticProviderDetailMaxLength);

export const semanticProviderDetailZod = z.union([
  z.object({ status: statusZod, message: messageZod.optional() }),
  z.object({ status: statusZod.optional(), message: messageZod }),
]);

export const semanticProviderFailureDetailsZod = z.object({
  provider_failed: semanticProviderDetailZod.optional(),
  provider_throttled: semanticProviderDetailZod.optional(),
});

export type SemanticProviderDetail = z.infer<typeof semanticProviderDetailZod>;
export type SemanticProviderFailureDetails = z.infer<
  typeof semanticProviderFailureDetailsZod
>;
